export const ORG_PREFERENCES = {
	ORG_ONBOARDING: 'org_onboarding',
	WELCOME_CHECKLIST_DO_LATER: 'welcome_checklist_do_later',
	WELCOME_CHECKLIST_SEND_LOGS_SKIPPED: 'welcome_checklist_send_logs_skipped',
	WELCOME_CHECKLIST_SEND_TRACES_SKIPPED: 'welcome_checklist_send_traces_skipped',
	WELCOME_CHECKLIST_SETUP_ALERTS_SKIPPED:
		'welcome_checklist_setup_alerts_skipped',
	WELCOME_CHECKLIST_SETUP_SAVED_VIEW_SKIPPED:
		'welcome_checklist_setup_saved_view_skipped',
	WELCOME_CHECKLIST_SEND_METRICS_SKIPPED:
		'welcome_checklist_send_metrics_skipped',
	WELCOME_CHECKLIST_SETUP_DASHBOARDS_SKIPPED:
		'welcome_checklist_setup_dashboards_skipped',
	WELCOME_CHECKLIST_SETUP_WORKSPACE_SKIPPED:
		'welcome_checklist_setup_workspace_skipped',
	WELCOME_CHECKLIST_ADD_DATA_SOURCE_SKIPPED:
		'welcome_checklist_add_data_source_skipped',
};
